import { SPEED_MIN, SPEED_MAX } from './layerTypeConfig';

const MIN_WINDOW = 0.1;

/** Change playback speed keeping `start` fixed: the window becomes
 *  (trimEnd − trimStart) / speed, clamped to the clip end (reducing trimEnd
 *  to preserve the invariant when clamped). */
export function applySpeedChange(
  { start, trimStart, trimEnd, speed, clipDuration }:
  { start: number; trimStart: number; trimEnd: number; speed: number; clipDuration: number },
): { speed: number; end: number; trimEnd: number } {
  const s = Math.min(SPEED_MAX, Math.max(SPEED_MIN, speed));
  let end = start + (trimEnd - trimStart) / s;
  let newTrimEnd = trimEnd;
  if (end > clipDuration) {
    end = clipDuration;
    newTrimEnd = trimStart + (end - start) * s;
  }
  if (end - start < MIN_WINDOW) {
    end = Math.min(clipDuration, start + MIN_WINDOW);
    newTrimEnd = trimStart + (end - start) * s;
  }
  return { speed: s, end, trimEnd: newTrimEnd };
}
